import React, { useEffect, useState } from 'react'
import FetchApi, { host } from '../../customhooks/functionFetchApi';
import Tablecolordetail from './tablecolordetail';
import { CiImageOn } from "react-icons/ci";
import { FaFileDownload } from "react-icons/fa";
import ViewImages from '../../form01/components/viewImages';
import Viewnewcolerprinting from './viewnewcolerprinting';

// import { styles } from "../../css/style";
const colorheader = {
    number: 0,
    colorheader: "",
    detailcolor: [],
    remark: ""
}

const ViewColorlist = ({ journalId }) => {

    const FetchApis = new FetchApi();

    const [JourColorHeader, setJourColorHeader] = useState([])
    const [jouranlheader, setJournalhead] = useState([])
    // detail ink
    const [colorlist1, setColorlist1] = useState(colorheader);
    const [colorlist2, setColorlist2] = useState(colorheader);
    const [colorlist3, setColorlist3] = useState(colorheader);
    const [colorlist4, setColorlist4] = useState(colorheader);
    const [colorlist5, setColorlist5] = useState(colorheader);
    const [colorlist6, setColorlist6] = useState(colorheader);
    const [colorlist7, setColorlist7] = useState(colorheader);
    //header ink
    const [colorall, setColorall] = useState({ colorheader: "", remark: "", typecolor: "", number: '' });
    const [colordetail, setColordetail] = useState({ inkname: "", formulate: "", kg1: "", kg2: "", colordetailId: "" })

    useEffect(() => {
        getColorhaeader(journalId)
        getjournalbyid(journalId)
    }, [])


    // function datalistjournal(jourId) {
    //     FetchApis.FethcGet(`/journal/journalbyId/${jourId}`).then((res) => {
    //         if (res.status == 200) {
    //             if (res.data.data.length > 0) {
    //                 setJournaldata(res.data.data[0]);
    //             }

    //         }
    //     })
    // }

    function getColorhaeader(journalId) {

        FetchApis.FethcGet(`/productcolor/getproductByjournal/${journalId}`).then((res) => {

            setJourColorHeader(res.data.data)
            // console.log(res.data.data);
        })

    }

    function getjournalbyid(journalId) {
        FetchApis.FethcGet(`/journal/journalbyId/${journalId}`).then(res => {
            if (res) {
                setJournalhead(res.data.data)
            }

        })
    }

    // function getproductcolor(jourId) {

    //     FetchApis.FethcGet(`/productcolor/getproductByjournal/${jourId}`).then((res) => {
    //         if (res) {
    //             console.log(res.data)
    //             let colorallss = res.data.data;

    // for (let index = 0; index < colorallss.length; index++) {
    //     let resultcolor = colorallss[index];

    //     if (resultcolor.number == 1) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)

    //     }

    //     if (resultcolor.number == 2) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }

    //     if (resultcolor.number == 3) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }

    //     if (resultcolor.number == 4) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }

    //     if (resultcolor.number == 5) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }
    //     if (resultcolor.number == 6) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }
    //     if (resultcolor.number == 7) {
    //         let tdcolor = colorallss[index];

    //         getproductcolordetail(resultcolor.colorId, resultcolor.number, tdcolor)
    //     }

    // }
    // setJournaldata(res.data.data[0]);
    //         }
    //     })
    // }

    // function getproductcolordetail(colorid, typenumber, resultcolor) {

    //     if (typenumber == 1) {
    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {
    //             const { colorheader, detailcolor, remark } = colorlist1;

    //             if (res.data.data.length > 0) {
    //                 setColorlist1({
    //                     ...colorlist1,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 1
    //                 })
    //             } else {
    //                 setColorlist1({
    //                     ...colorlist1,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 1
    //                 })
    //             }

    //         })
    //     }

    //     if (typenumber == 2) {
    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {
    //             // console.log(res.data.data)
    //             const { colorheader, detailcolor, remark } = colorlist2;

    //             if (res.data.data.length > 0) {
    //                 setColorlist2({
    //                     ...colorlist2,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 2
    //                 })
    //             } else {
    //                 setColorlist2({
    //                     ...colorlist2,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 2
    //                 })
    //             }
    //         })
    //     }

    //     if (typenumber == 3) {
    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {

    //             const { colorheader, detailcolor, remark } = colorlist3;

    //             if (res.data.data.length > 0) {
    //                 setColorlist3({
    //                     ...colorlist3,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 3
    //                 })
    //             } else {
    //                 setColorlist3({
    //                     ...colorlist3,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 3
    //                 })
    //             }
    //         })
    //     }

    //     if (typenumber == 4) {

    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {

    //             const { colorheader, detailcolor, remark } = colorlist4;
    //             if (res.data.data.length > 0) {
    //                 setColorlist4({
    //                     ...colorlist4,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 4
    //                 })
    //             } else {
    //                 setColorlist4({
    //                     ...colorlist4,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 4
    //                 })
    //             }
    //         })
    //     }

    //     if (typenumber == 5) {

    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {

    //             const { colorheader, detailcolor, remark } = colorlist5;
    //             if (res.data.data.length > 0) {
    //                 setColorlist5({
    //                     ...colorlist5,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 5
    //                 })
    //             } else {
    //                 setColorlist5({
    //                     ...colorlist5,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 5
    //                 })
    //             }
    //         })
    //     }


    //     if (typenumber == 6) {

    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {

    //             const { colorheader, detailcolor, remark } = colorlist6;
    //             if (res.data.data.length > 0) {
    //                 setColorlist6({
    //                     ...colorlist6,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 6
    //                 })
    //             } else {
    //                 setColorlist6({
    //                     ...colorlist6,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 6
    //                 })
    //             }
    //         })
    //     }


    //     if (typenumber == 7) {

    //         FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorid}`).then((res) => {

    //             const { colorheader, detailcolor, remark } = colorlist7;
    //             if (res.data.data.length > 0) {
    //                 setColorlist7({
    //                     ...colorlist7,
    //                     colorheader: resultcolor.colorname,
    //                     detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 7
    //                 })
    //             } else {
    //                 setColorlist7({
    //                     ...colorlist7,
    //                     colorheader: resultcolor.colorname,
    //                     // detailcolor: res.data.data,
    //                     remark: resultcolor.remark,
    //                     number: 7
    //                 })
    //             }
    //         })
    //     }


    // }


    return (
        <div>
            {/* <div>
                {colorlist1.colorheader != "" && <Tablecolordetail data={colorlist1} />}
                {colorlist2.colorheader != "" && <Tablecolordetail data={colorlist2} />}
                {colorlist3.colorheader != "" && <Tablecolordetail data={colorlist3} />}
                {colorlist4.colorheader != "" && <Tablecolordetail data={colorlist4} />}

                {colorlist5.colorheader != "" && <Tablecolordetail data={colorlist5} />}
                {colorlist6.colorheader != "" && <Tablecolordetail data={colorlist6} />}
                {colorlist7.colorheader != "" && <Tablecolordetail data={colorlist7} />}
            </div> */}
            {jouranlheader.length>0&&<div style={{padding:10}}>
                <div style={{ width: '100%', fontSize: 12, fontWeight: '800' }}>
                    <table style={{ marginBottom: 5, border: '0.5' ,width:'100%',fontSize:14}}>
                        <th>
                            <td style={{flexDirection: 'column', justifyContent: 'center' ,width:'60%',padding:5}}>
                                <label style={{ fontWeight: 'bold', fontSize: 12 }}>TECHNICAL DATA SHEET PART ( B ) </label>
                                <label style={{ fontWeight: 'bold', fontSize: 12 }}>เอกสารหมีกผสม แนบท้าย Printing </label>
                            </td>
                            <td style={{width:'20%',padding:5}}>
                                <label style={{ marginLeft: 3 }}>Ref. MK. NO : {jouranlheader[0].tdscode}</label>
                            </td>
                            <td style={{width:'30%',padding:5}}>
                                <label style={{ marginLeft: 3 }}>Date : {jouranlheader[0].createdatetime}</label>
                            </td>
                        </th>
                    </table>
                    <div>
                        {JourColorHeader.map((item, i) => (
                            <div style={{width:'100%'}}>
                                <label style={{ fontWeight: 'bold', backgroundColor: '#e5e7e9' }}>{i + 1}.Color :{item.colorname}</label>
                                <Viewnewcolerprinting colorId={item.colorId} />
                                <label style={{ fontWeight: 'bold' }}>Remarks : {JourColorHeader[0].remark} </label>
                            </div>
                        ))
                        }

                    </div>
                </div>
            </div>}
            <hr></hr>
            {/* {jouranlheader.uploadfilecolor != "" &&
                <div>
                    <div className='row-page'>
                        <label style={{ fontSize: 16 }}><b>รูปประกอบ</b></label>
                        <ViewImages urlImages={jouranlheader.uploadfilecolor} />
                    </div>

                    <div>
                        {jouranlheader.uploadfilecolor != "" ?
                            <img src={host + '/images/files/' + jouranlheader.uploadfilecolor}
                                style={{ width: 100, hidden: 100 }} /> : <CiImageOn size={50} />}
                    </div>
                    <div>
                        {jouranlheader.uploadfilecolor != "" && <div>
                            <a href={host + `/images/files/${jouranlheader.uploadfilecolor}`} ><FaFileDownload size={20} /> download</a>
                        </div>}
                    </div>
                </div>} */}
        </div>
    )
}

export default ViewColorlist